<template>
  <div>
    <div class="ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <section class="investment__section">
            <div class="investment__section__sidebar">
              <h4>Donation Term</h4>
              <div class="investment__desc">Choose your donation plan</div>
            </div>
            <div class="investment__section__main">
              <h4>Donation Term</h4>
              <div class="frequency">
                <PaymentOptions addMonthly />
              </div>
            </div>
          </section>
          <section class="investment__section">
            <div class="investment__section__sidebar">
              <h4>Donation Amount</h4>
              <div class="investment__desc">Choose the amount of your donation</div>
            </div>
            <div class="investment__section__main">
              <div class="investment__options">
                <h4>Donation Amount</h4>
                <AmountSelector />
                <ErrorLabel field="amount" />
              </div>
              <div class="investment__recipent">
                <InHonorOf :recipent="false" />
              </div>
            </div>
          </section>
          <section class="investment__section">
            <div class="investment__section__sidebar">
              <h4>Personal Information</h4>
              <div class="investment__desc">provide your billing information</div>
            </div>
            <div class="investment__section__main">
              <div class="investment__personal">
                <FormRow inline>
                  <FormCol field="title" :flex="1" />
                  <FormCol field="firstName" :flex="2" />
                  <FormCol field="lastName" :flex="2" />
                </FormRow>
                <FormRow inline>
                  <FormCol field="email" />
                  <FormCol field="phone" />
                </FormRow>
                <FormRow inline>
                  <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow>
                <br />
                <DonorAddress />
                <FormRow>
                  <NewsletterSubscribe
                    text="Yes, I would like to join the Accelerator mailing list"
                  />
                </FormRow>
              </div>
            </div>
          </section>

          <section class="investment__section">
            <div class="investment__section__sidebar">
              <h4>Payment Information</h4>
              <div class="investment__desc">provide your payment information</div>
            </div>
            <div class="investment__section__main">
              <div class="investment__payment">
                <FormRow inline>
                  <FormCol field="card" :showLabel="false" />
                </FormRow>
              </div>
              <div class="investment__btn">
                <PaymentButton showAmount btnText="Donate Now" />
              </div>
            </div>
          </section>
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
section.investment__section {
  display: flex;
  max-width: 1216px;
  margin: 0px auto 49px;
  background: #ffffff;
  box-shadow: 0px 0px 18px -8px rgba(0, 0, 0, 0.1);
  border-radius: 4px;

  @media only screen and (max-width: 720px) {
    flex-flow: column;
    margin: 0px auto;
  }
  .investment__section__sidebar {
    background: #eff2f6;
    border-radius: 4px;
    flex: 1;
    padding: 15px;

    @media only screen and (min-width: 720px) {
      flex: 0 1 384px;
      padding: 48px 0px 0px 43px;
    }
    h4 {
      font-family: "Poppins";
      font-style: normal;
      font-weight: 600;
      font-size: 18px;
      line-height: 18px;
      letter-spacing: 0.75px;
      color: #232e38;
      margin-bottom: 4px;
    }

    .investment__desc {
      font-family: "Poppins";
      font-style: normal;
      font-weight: 400;
      font-size: 15px;
      line-height: 24px;
      letter-spacing: 0.75px;
      color: #4b5866;
    }
  }
  .investment__section__main {
    max-width: 832px;
    padding: 40px 33px;
    width: 100%;
    @media only screen and (max-width: 720px) {
      padding: 20px;
    }
    h4 {
      font-family: "Poppins";
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 15px;
      letter-spacing: 0.75px;
      color: #232e38;
      margin-bottom: 12px;
    }
  }
}

h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}

::v-deep .ou-donation-form {
  h2 {
    text-align: left;
    font-size: 17px;
  }

  label {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 15px;
    letter-spacing: 0.75px;
    color: #4b5866;
  }

  .amount_other__wrapper {
    background: white;
    border: 1px solid #1e50b4;
    filter: drop-shadow(0px 0px 16px rgba(0, 0, 0, 0.04));
    border-radius: 6px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 24px;
    display: flex;
    align-items: center;
    letter-spacing: 0.75px;
    text-transform: uppercase;
    color: #1e50b4;

    @media only screen and (max-width: 720px) {
      min-width: 140px;
      max-width: 140px;
    }

    input#amount_other_check {
      position: absolute;
    }

    input#amount_other_field {
      background: #fff;
      height: 100%;
      margin-left: 26px;
      margin-top: 0px;
      font-family: "Poppins";
      font-style: normal;
      font-weight: 600;
      font-size: 15px;
      line-height: 24px;
      letter-spacing: 0.75px;
      text-transform: uppercase;
      color: #1e50b4;
    }
  }

  button.ou-donation-btn {
    border: 2px solid #1e50b4;
    border-radius: 6px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 24px;
    display: flex;
    align-items: center;
    text-align: center;
    height: 56px;
    background: white;
    color: #1e50b4;
    path {
      fill: #1e50b4;
    }
    &:hover {
      background: #1e50b4;
      border-radius: 6px;
      color: white;
      path {
        fill: white;
      }
    }
  }

  .investment__recipent {
    label {
      font-family: "Poppins";
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 15px;
      letter-spacing: 0.75px;
      color: #4b5866;
    }
  }

  label {
    font-size: 14px;
    color: black;
    font-weight: normal;
    padding-top: 3px;
    padding-bottom: 3px;
    display: block;
    margin-bottom: 0px;
  }
  .investment__head {
    h2 {
      text-align: center;
      margin: 13px 0px 0px;
      font-size: 17px;
    }
  }
  .styled-radio-container--ou-donation.styled-radio-container {
    // justify-content: center;
    gap: 8px;
    .radio-part {
      min-width: 162px;
      max-width: 162px;
      height: 56px;
      padding: 0px;
    }

    @media only screen and (min-width: 720px) {
      gap: 32px;
    }
  }
  .styled-radio--ou-donation.styled-radio {
    // justify-content: center;
    gap: 17px;
    .radio-part {
      min-width: 140px;
      max-width: 140px;
      height: 56px;
      padding: 0px;
    }
  }
  .styled-radio--ou-donation.styled-radio label {
    background: white;
    border: 1px solid #1e50b4;
    filter: drop-shadow(0px 0px 16px rgba(0, 0, 0, 0.04));
    border-radius: 6px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 24px;
    display: flex;
    align-items: center;
    letter-spacing: 0.75px;
    text-transform: uppercase;
    color: #1e50b4;

    &:hover {
      background: #133271;
      box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.04);
      border-radius: 6px;
      color: white;
    }
  }

  .styled-radio--ou-donation.styled-radio input[type="radio"]:checked + label {
    background: #133271;
    box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.04);
    border-radius: 6px;
    color: white;
  }

  @media only screen and (min-width: 720px) {
    input[type="tel"] {
      height: 42px;
      box-sizing: border-box;
      width: 100%;
      display: block;
      border: 1px solid #ddd;
      padding: 0 10px;
      border-radius: 4px;
      background: #f7f9fb;
      transition: all 0.3s ease-in-out;
      font-size: 16px;
      color: #222;
    }
  }
  .styled-radio.styled-radio--ou-donation.row {
    .radio-part {
      @media only screen and (min-width: 720px) {
        min-width: 20%;
        max-width: 20%;
      }
    }
  }
  .styled-radio-container--ou-donation.styled-radio-container .radio-part {
    input[type="radio"]:checked + label {
      background: #133271;
      box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.04);
      border-radius: 6px;
      color: white;
      &:before {
        background: #133271;
        box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.04);
        border-radius: 6px;
      }
    }

    label {
      border: 1px solid #1e50b4;
      filter: drop-shadow(0px 0px 16px rgba(0, 0, 0, 0.04));
      border-radius: 6px;
      display: flex;
      justify-content: center;
      background: transparent;
      text-align: center;
      font-family: "Poppins";
      font-style: normal;
      font-weight: 600;
      font-size: 15px;
      line-height: 24px;
      display: flex;
      gap: 8px;
      align-items: center;
      letter-spacing: 0.75px;
      text-transform: uppercase;
      color: #1e50b4;

      &:hover {
        background: #133271;
        box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.04);
        border-radius: 6px;
        color: white;
      }
      &:before {
        // width: 80px;
        // display: flex;
        // height: 80px;
        // flex-flow: column;
        // margin: 0px auto 10px;
        // background: #dadada;
        // border-radius: 50%;
        // justify-content: center;
        // align-items: center;
      }
    }
    &:first-of-type {
      label {
        &:before {
          content: url("https://res.cloudinary.com/orthodox-union/image/upload/f_auto,q_auto/v1658662956/accelerator/2022/Target1.png");
        }
        &:hover {
          &:before {
            content: url("https://res.cloudinary.com/orthodox-union/image/upload/v1658662956/accelerator/2022/Target1w.png");
          }
        }
      }
      input[type="radio"]:checked + label {
        &:before {
          content: url("https://res.cloudinary.com/orthodox-union/image/upload/v1658662956/accelerator/2022/Target1w.png");
        }
      }
    }
    &:last-of-type {
      label {
        &:before {
          content: url("https://res.cloudinary.com/orthodox-union/image/upload/f_auto,q_auto/v1658662956/accelerator/2022/Target2.png");
        }
        &:hover {
          &:before {
            content: url("https://res.cloudinary.com/orthodox-union/image/upload/v1658662956/accelerator/2022/Target2w.png");
          }
        }
      }
      input[type="radio"]:checked + label {
        &:before {
          content: url("https://res.cloudinary.com/orthodox-union/image/upload/v1658662956/accelerator/2022/Target2w.png");
        }
      }
    }
  }
}

.investment__payment,
.investment__options {
  margin-bottom: 30px;
}
</style>
